import cn from 'classnames';
import { useHistory } from 'react-router-dom';
import { useCallback } from 'react';

//GraphQL
import { useDeleteProfileMutation } from '~graphqlResources';
//Hooks
import useOnGraphQLError from '~hooks/useOnGraphQLErrors';
import { useAuthContext } from '~context/auth';
import { useCommonModals } from '~context/commonModals';
//Config
import { deleteProfileSuccessRoute } from '~config/routes';



export interface IDeleteAccountBtnProps {
    type?: 'text' | 'button'
    label?: string
    className?: string
}

export default function DeleteAccountBtn({type = 'button', label = 'Delete my account', className}: IDeleteAccountBtnProps) {
    const handleGraphQLError = useOnGraphQLError();
    const {openErrorModal, openConfirmModal} = useCommonModals();
    const {push} = useHistory();
    const {logout} = useAuthContext();

    const [deleteProfile, {loading: mutationLoading}] = useDeleteProfileMutation({
        onError: handleGraphQLError()
    });

    const submitDeleteProfile = useCallback(
        async () => {
            try {
                const resp = await deleteProfile();

                if (resp?.data?.deleteProfile?.success) {
                    logout({
                        onlyLocal: true,
                        onFinish() {
                            push(deleteProfileSuccessRoute);
                        }
                    });
                } else {
                    openErrorModal();
                }
            } catch (e) {
                openErrorModal();
            }
        },
        [deleteProfile, logout, openErrorModal, push]
    );

    const handleDeleteProfile = () => openConfirmModal({
        title: 'You are about to delete your Talentprise account.',
        modalBody: 'If you deleted your account, you wouldn’t be able to retrieve your information',
        onConfirm: submitDeleteProfile
    });

    return (
        <button
            type="button"
            className={cn('btn delete-account-btn', {'delete-account-btn--text': type === 'text'}, `${className}`)}
            disabled={mutationLoading}
            onClick={handleDeleteProfile}
        >
            {label}
        </button>
    );
}
